import { Injectable, inject, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserGroup } from '../models/user-group.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  public async getUserGroups(): Promise<UserGroup[]> {
    if (this.userGroupsSignal().length > 0) {
      return this.userGroupsSignal();
    } else {
      const userGroup = await this.API.get(environment.API_NAME, '/groups');
      this.userGroupsSignal.set(userGroup);

      return this.userGroupsSignal();
    }
  }

  private readonly API = inject(ApiService);
  private readonly userGroupsSignal = signal<UserGroup[]>([]);
}
